/**
 * Legacy: Modal
 *
 * @module legacy/LModal
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	var $videoSRC,
		$iframe = $("#modal_iframe");

	// END | MODAL FUNCTIONS

	// BEGIN | PERSON MODAL POP UP

	// $('.team-member-module .card').on('click', function (e) {
	// 	e.preventDefault();

	// 	var $img = $(this).attr('data-image'),
	// 		$name = $(this).attr('data-name'),
	// 		$title = $(this).attr('data-title'),
	// 		$bio = $(this).attr('data-bio'),
	// 		$twitter = $(this).attr('data-twitter'),
	// 		$linkedin = $(this).attr('data-linkedin'),
	// 		$facebook = $(this).attr('data-facebook');

	// 	openPersonModal($img, $name, $title, $bio, $twitter, $linkedin, $facebook);
	// });

	// END | PERSON MODAL POP UP

	// BEGIN | VIDEO MODAL POP UP

	$("a").on("click", function (e) {
		if (!$(this)[0].hasAttribute('href')) {
			return;
		}

		var thisLink = $(this);
		thisLink.addClass('back-to-me');
		var linkUrl = $(this).attr("href"),
			lastFour = linkUrl.substr(linkUrl.length - 4),
			a = new RegExp("/" + window.location.host + "/");

		// DETECT IF LINKL IS NOT MODAL

		if ($(this).hasClass("nomodal")) {
			console.log(" no modal");
			window.open(linkUrl, "_blank");
			return false;
		}

		// $('#modal_video[role=dialog]').on('keydown', function(e) {
		// 	var target = e.target;
		// 	var shiftPressed = e.shiftKey;
		// 	// If TAB key pressed
		// 	if (e.keyCode == 9) {
		// 		// If inside a Modal dialog (determined by attribute role="dialog")
		// 		if ($(target).parents('[role=dialog]').length) {
		// 			// Find first or last input element in the dialog parent (depending on whether Shift was pressed).
		// 			// Input elements must be visible, and can be Input/Select/Button/Textarea.
		// 			var borderElem = shiftPressed ?
		// 								$(target).closest('[role=dialog]').find('input:visible,select:visible,button:visible,textarea:visible,object:visible,a:visible,area:visible').first()
		// 							 :
		// 								$(target).closest('[role=dialog]').find('input:visible,select:visible,button:visible,textarea:visible,object:visible,a:visible,area:visible').last();
		// 			if ($(borderElem).length) {
		// 				if ($(target).is($(borderElem))) {
		// 					return false;
		// 				} else {
		// 					return true;
		// 				}
		// 			}
		// 		}
		// 	}
		// 	return true;
		// });


		// detect for youtube
		if (
			linkUrl.substr(0, linkUrl.indexOf("youtu.be/")) !== -1 &&
			linkUrl.indexOf("youtu.be/") !== -1
		) {
			e.preventDefault();
			var videoUrlPartial = linkUrl.substr(linkUrl.lastIndexOf("/") + 1);
			var embedUrl =
				"https://www.youtube.com/embed/" + videoUrlPartial + "?rel=0&autoplay=1";
			openVideoModal(embedUrl);
			$('#modal_video[role=dialog]').focus();
			console.log("youtube open");
		}

		// detect for vimeo
		else if (linkUrl.indexOf("vimeo.com") !== -1) {
			e.preventDefault();
			console.log("vimeo open");
			var videoUrlPartial = linkUrl.substr(linkUrl.lastIndexOf("/") + 1);
			var embedUrl =
				"https://player.vimeo.com/video/" + videoUrlPartial + "?rel=0&autoplay=1";
			openVideoModal(embedUrl);
		}

		// detect for local video
		else if (lastFour === ".mp4" || lastFour === ".mov" || lastFour === "webm") {
			e.preventDefault();
			openVideoModal(linkUrl);
			console.log("local open");
		}

		// detect for PDF or outbound link (open in new tab)
		else if (lastFour === ".pdf") {
			e.preventDefault();
			e.stopPropagation();
			window.open(linkUrl, "_blank");
		}
	});

	// END | VIDEO MODAL POP UP

	// BEGIN | CLOSE MODALS

	$("#modal_video").on("closed.zf.reveal", function () {
		console.log("modal closed");
		closeVideoModal();
		$('.back-to-me').focus();
		$('.back-to-me').removeClass('back-to-me');
	});

	$("body").on("click", "#modal_bg, #modal_close, .close-button", function () {
		//	closePersonModal();
		console.log("you clicked body");
		closeVideoModal();
		$("#modal_video, #modal_person").foundation("close");
	});

	$(".reveal-overlay").on(
		"click",
		"#modal_bg, #modal_close, .close-button",
		function () {
			//	closePersonModal();
			closeVideoModal();
			console.log("you clicked reveal");
			$("#modal_video, #modal_person").foundation("close");
		}
	);
}

function openPersonModal(img, name, title, bio, twitter, linkedin, facebook) {
	$("#modal_person .person-image").attr("src", img);
	$("#modal_person .name").text(name);
	$("#modal_person .title").text(title);
	$("#modal_person .bio").text(bio);
	$("#modal_person .twitter").attr("href", twitter);
	$("#modal_person .linkedin").attr("href", linkedin);
	$("#modal_person .facebook").attr("href", facebook);
	$("body").addClass("frozen");
	$("#modal_person").addClass("active");
	$("#modal_person").foundation("open");
}

//function closePersonModal() {
//	$('body').removeClass('frozen');
//	$('#modal_person').removeClass('active');
//}

// Target the iFrame
function setFocusThickboxIframe() {
	var iframe = $("#modal_iframe")[0];
	iframe.contentWindow.focus();
}

function openVideoModal(src) {
	// $('body').addClass('frozen');
	$("#modal_video").addClass("active");
	$("#modal_iframe").attr("src", src).show();
	$("#modal_video").foundation("open");
	setTimeout(setFocusThickboxIframe, 100);
}

function closeVideoModal() {
	$("body").removeClass("frozen");
	$("#modal_video, #modal_person").removeClass("active");

	$("#modal_iframe").attr("src", "").hide();
}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
